import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRODUCT_NAME } from '../data/content';
export function Hero() {
  return <header className="border-b border-crema bg-blanco" data-id="element-86" data-mp="ei1vfm5pk2xy">
      <div className="mx-auto max-w-3xl px-4 pb-6 pt-4 text-center sm:pt-7" data-id="element-87" data-mp="9lla0zpw82ok">
        <p className="text-xs font-bold uppercase tracking-wide text-petroleo sm:text-sm" data-id="element-88" data-mp="4mi3tby6fqf0">
          ✨ MÉTODO DE TRANSFORMACIÓN PASO A PASO
        </p>
        <h1 className="mt-1.5 font-serif text-[1.9rem] font-bold leading-[1.1] text-azul sm:text-5xl" data-id="element-89" data-mp="127ecf87a1fat">
          El sistema completo para{' '}
          <span className="bg-dorado/30 px-1 text-petroleo" data-id="element-90" data-mp="sai5h6x1118d">volver a tomar el control de tu vida</span>
        </h1>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-snug text-azul/80 sm:text-base" data-id="element-91" data-mp="nb6njukxbpp7">
          Ordená tu mente, recuperá tus prioridades, construí mejores hábitos y
          creá una dirección clara para avanzar — sin seguir acumulando consejos,
          videos y métodos que nunca terminás aplicando.
        </p>

        <p className="mt-3 rounded-lg bg-petroleo px-3 py-2 text-[0.72rem] font-extrabold uppercase leading-tight text-blanco sm:text-sm" data-id="element-92" data-mp="3j9agbasosm43">
          ✨ {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </p>

        <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mt-2.5 block overflow-hidden rounded-2xl border-[3px] border-dorado bg-white transition-transform duration-150 ease-soft active:scale-[0.99]" data-id="element-93" data-mp="39a38f34q1jod">
          <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-94" data-mp="359t0vm1a6l7e" />
        </a>

        <CtaBlock note="Acceso Digital Inmediato • Garantía de 7 Días" data-id="element-95" data-mp="2qkmthasahoof" />
      </div>
    </header>;
}